import { memo, type ReactElement } from 'react'

interface TransactionsIconProps {
  active: boolean
}

function TransactionsIcon ({ active }: TransactionsIconProps): ReactElement {
  return (
    <svg fill={active ? '#FFF' : '#7F95A0'} xmlns="http://www.w3.org/2000/svg" height="1.5em" viewBox="0 0 448 512">
      <path d="M25.4 406.6l80 80L128 509.3 173.3 464l-22.6-22.6L125.3 416 416 416l32 0 0-64-32 0-290.7 0 25.4-25.4L173.3 304 128 258.7l-22.6 22.6-80 80L2.7 384l22.6 22.6zm397.3-256L445.3 128l-22.6-22.6-80-80L320 2.7 274.7 48l22.6 22.6L322.7 96 32 96 0 96l0 64 32 0 290.7 0-25.4 25.4L274.7 208 320 253.3l22.6-22.6 80-80z" />
    </svg>
  )
}

export default memo(TransactionsIcon)
